import { render, staticRenderFns } from "./FileUploadField.vue?vue&type=template&id=2995c49e&"
import script from "./FileUploadField.vue?vue&type=script&lang=js&"
export * from "./FileUploadField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports